import React,{useRef,useState} from "react";
import emailjs from "@emailjs/browser";
import "../../style_new.css";
import Loader from "../Loader";
const SERVICE_ID = "service_gt2azly";
const TEMPLATE_ID = "template_zrcxke8";
const PUBLIC_KEY = "GTUWxDDlO2Nswdvjo";

const Contact = () => {
  const formRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handelSubmit =async(e)=>{
   e.preventDefault();
    if (!formRef.current) return;

    const form = formRef.current;
    const formData = new FormData(form);

    const requiredFields = ["name", "email", "phone", "subject", "message"];
    for (const field of requiredFields) {
      if (!formData.get(field)) {
        alert("Please fill in all fields.");
        return;
      }
    }

    setIsSubmitting(true);

    try {
      await emailjs.sendForm(
        SERVICE_ID,
        TEMPLATE_ID,
        formRef.current,
        PUBLIC_KEY
      );
      alert("Message sent successfully!");
      form.reset();
    } catch (error) {
      alert("Something went wrong, please try again.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <div class="container-xxl py-5">
        <div class="container">
          <div class="row g-5">
            {/* <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="row g-4 align-items-center">
                <div class="col-sm-6">
                  <img class="img-fluid" src="./images/team-1.jpg" alt="" />
                </div>
                <div class="col-sm-6">
                  <h3 class="mb-0">Full Name</h3>
                  <p>Head of Sales</p>
                  <h6>Contact Details</h6>
                  <p>
                    Lorem ipsum dolor sit amet conse elit sed eiu smod lab ore.
                  </p>
                  <p class="mb-0">Call: +012 345 6789</p>
                  <p class="mb-0">Email: sales@example.com</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="row g-4 align-items-center">
                <div class="col-sm-6">
                  <img class="img-fluid" src="./images/team-2.jpg" alt="" />
                </div>
                <div class="col-sm-6">
                  <h3 class="mb-0">Full Name</h3>
                  <p>Head of Marketing</p>
                  <h6>Contact Details</h6>
                  <p>
                    Lorem ipsum dolor sit amet conse elit sed eiu smod lab ore.
                  </p>
                  <p class="mb-0">Call: +012 345 6789</p>
                  <p class="mb-0">Email: sales@example.com</p>
                </div>
              </div>
            </div> */}
            <div
              class="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: "450px" }}
            >
              <div class="position-relative h-100">
              
                <iframe 
                title="Our Location"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d22394.685400401337!2d-1.621314810523636!3d6.592785760977138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNsKwMzUnMjMuOSJOIDHCsDM3JzMwLjQiVw!5e0!3m2!1sen!2sgh!4v1747403324621!5m2!1sen!2sgh" 
                width="600" 
                height="600" 
                style={{ minHeight: "450px", border: 0 }}
                allowfullscreen="" 
                loading="lazy" 
                referrerpolicy="no-referrer-when-downgrade">

                </iframe>
               
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="border-start border-5 border-primary ps-4 mb-5">
                <h6 class="text-body text-uppercase mb-2">Contact Us</h6>
                <h1 class="display-6 mb-0">
                  If You Have Any Query, Please Contact Us
                </h1>
              </div>
              <p class="mb-4">
                Contact us for all your enquiries. We respond within a day.
              </p>
              <form ref={formRef} onSubmit={handelSubmit}>
                <div class="row g-3">
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control border-0 bg-light"
                        id="name"
                        placeholder="Your name"
                        name="name"
                        required
                      />
                      <label for="subject">Name</label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control border-0 bg-light"
                        id="email"
                        placeholder="Your Email address"
                        name="email"
                        required
                      />
                      <label for="name">Email</label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-floating">
                      <input
                        type="number"
                        class="form-control border-0 bg-light"
                        id="phone"
                        placeholder="Your phone number"
                        name="phone"
                        required
                      />
                      <label for="email">Phone</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control border-0 bg-light"
                        id="subject"
                        placeholder="Subject"
                        name="subject"
                        required
                      />
                      <label for="subject">Subject</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <textarea
                        class="form-control border-0 bg-light"
                        placeholder="Leave a message here"
                        id="message"
                        style={{ height: "150px" }}
                        name="message"
                        required
                      ></textarea>
                      <label for="message">Message</label>
                    </div>
                  </div>
                  {isSubmitting ? <Loader/> :
                   <div class="col-12">
                    <button class="btn btn-primary py-3 px-5" type="submit" >
                      Send Message
                    </button>
                  </div>
                  }
                 
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
